module.exports = __webpack_public_path__ + "img/zmd.4299794d.png";